import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { BackendModule } from '@shared/datastore/core';
import { usersBackend } from './users.backend';
import { usersReducer } from './users.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('users', usersReducer),
    BackendModule.forFeature('users', usersBackend),
  ],
})
export class DatastoreUsersModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/users/users.module.ts